import script from "./ToolsHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolsHome.vue?vue&type=script&setup=true&lang=ts"

import "./ToolsHome.vue?vue&type=style&index=0&id=228d228a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-228d228a"]])

export default __exports__